module.exports = __webpack_public_path__ + "static/media/pejzazh_gory_ozero_160353_1280x1024.5f3f085f.jpg";